/**
 * OVERRIDE: View.jsx
 * REASON: Supporting Location relation
 * DATE: 2025-07-29
 * DEVELOPER: @ericof
 */

import View from '../../../../../../components/Blocks/EventMetadata/View';

export default View;
